// extracted by mini-css-extract-plugin
export default {"app":"layout_app__JMn6U","body":"layout_body__lCLog","bottom":"layout_bottom__W3UKz"};